import React, { memo } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
} from "recharts";
import DashboardChartCard from "./DashboardChartCard";

const CHART_MARGIN = { top: 8, right: 12, left: 0, bottom: 0 };
const COMPLETED_COLOR = "#5b9cf5";
const OVERDUE_COLOR = "#f4a4a4";
const TAT_COLOR = "#86efac";

const OverdueTrendChart = ({ rows = [], xAxisKey = "person", teamView = "ic" }) => (
  <DashboardChartCard
    title={xAxisKey === "department" ? "Overdue Trend — Department" : teamView === "ic" ? "Overdue Trend" : "Overdue Trend — Team"}
    subtitle={xAxisKey === "department" ? "Completed, overdue, and TAT count per department" : teamView === "ic" ? "Completed, overdue, and TAT count over time" : "Completed, overdue, and TAT count per person"}
  >
    <div className="dashboard-chart-scroll-container">
      <div style={{ minWidth: `max(100%, ${(rows?.length || 0) * 60}px)`, height: 220 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows} margin={CHART_MARGIN} barGap={4} barCategoryGap="18%">
        <CartesianGrid vertical={false} stroke="#f0f1f3" />
        <XAxis
          dataKey={xAxisKey}
          tick={{ fill: "#5b5b5c", fontSize: 11 }}
          axisLine={false}
          tickLine={false}
          dy={8}
        />
        <YAxis
          tick={{
            fill: "#5b5b5c",
            fontSize: 12
          }}
          axisLine={false}
          tickLine={false}
          width={28}
        />
        <Tooltip
          cursor={{ fill: "rgba(243, 244, 246, 0.5)" }}
          contentStyle={{
            borderRadius: 8,
            border: "1px solid #e8eaed",
            fontSize: 12,
          }}
        />
        <Legend
          verticalAlign="top"
          height={36}
          iconType="square"
          wrapperStyle={{ fontSize: "12px", paddingBottom: "8px" }}
        />
        <Bar
          dataKey="completed"
          name="Completed"
          fill={COMPLETED_COLOR}
          radius={[4, 4, 0, 0]}
          maxBarSize={18}
          isAnimationActive={false}
        />
        <Bar
          dataKey="overdue"
          name="Overdue"
          fill={OVERDUE_COLOR}
          radius={[4, 4, 0, 0]}
          maxBarSize={18}
          isAnimationActive={false}
        />
        <Bar
          dataKey="tatCount"
          name="TAT count"
          fill={TAT_COLOR}
          radius={[4, 4, 0, 0]}
          maxBarSize={18}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
  </DashboardChartCard>
);

export default memo(OverdueTrendChart);
